import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [profile, setProfile] = useState(null);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setProfile(data.profile || data.manufacturer || null);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    refresh();
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    setProfile(null);
  };

  return (
    <AuthContext.Provider value={{ user, profile, setProfile, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
